import React from "react";
import "./Advisors.css";

import Mahesh from "../assets/Mahesh.png";
import Deb from "../assets/deb.png";
import David from "../assets/David.png";
import Emily from "../assets/Emily.png";
import Chris from "../assets/Chris.png";
import Pawel from "../assets/pawel.png";

/* Advisor logos */
import google from "../assets/google.png";
import bolt from "../assets/Bolt_logo.png";
import amazon from "../assets/amazon-dark.png";
import cjbs from "../assets/cambridge.png";
import imperial from "../assets/imperial-white.png";
import pa from "../assets/pa.png";
import venner from "../assets/veneer.png";
import nhs from "../assets/nhs.png";
import cambridge from "../assets/cambridge-white.png";

const advisors = [
  {
    name: "Mahesh Bhalerao",
    role: "Senior Partner, Global Director",
    image: Mahesh,
    logos: [google],
    position: "center 18%",
  },
  {
    name: "Debabrata Nag",
    role: "C Level @ Bolt · Ex Starcloud Advisor",
    image: Deb,
    logos: [bolt, amazon],
    position: "center 16%",
  },
  {
    name: "Dr. David Russell",
    role: "Partner @ PA Global Innovation & Tech Centre",
    image: David,
    logos: [pa, cambridge],
    position: "center 18%",
  },
  {
    name: "Dr. Pawel Piotrowicz",
    role: "Partner, Patent, UPC Representative",
    image: Pawel,
    logos: [venner, cambridge],
    position: "center 18%",
  },
  {
    name: "Dr. Emily Faulkner",
    role: "Innovation Scientist",
    image: Emily,
    logos: [nhs, cambridge],
    position: "center 18%",
  },
  {
    name: "Dr. Chris Thomas",
    role: "Expert in Residence",
    image: Chris,
    logos: [imperial, cambridge],
    position: "center 18%",
  },
];

export default function Advisors() {
  return (
    <main className="wAdvisorsPage">
      <section className="wAdvisorsSection">

        <div className="wAdvisorsHeader">

          <h1>
            Industry Advisors
          </h1>
        </div>

        <div className="wAdvisorsGrid">
          {advisors.map((advisor) => (
            <article
              className="wAdvisorProfile"
              key={advisor.name}
            >
              <div className="wAdvisorProfile__portrait">
                <img
                  src={advisor.image}
                  alt={advisor.name}
                  style={{
                    objectPosition:
                      advisor.position || "center top",
                  }}
                />
              </div>

              <div className="wAdvisorProfile__info">
                <h2>
                  {advisor.name}
                </h2>

                <p className="wAdvisorProfile__role">
                  {advisor.role}
                </p>
              </div>

              <div className="wAdvisorProfile__logos">
                {advisor.logos.map((logo, index) => (
                  <div
                    className="wAdvisorProfile__logo"
                    key={`${advisor.name}-${index}`}
                  >
                    <img
                      src={logo}
                      alt=""
                    />
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>

      </section>
    </main>
  );
}